import { cn } from "@/lib/utils"

export default function Loader({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "h-7 w-7 animate-spin rounded-full border-2 border-gray-200 border-t-gray-900 dark:border-gray-700 dark:border-t-gray-300",
        className
      )}
      role="status"
      aria-label="Loading"
    />
  )
}
